import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const splideClass = document.getElementsByClassName('splide')[0];

if(splideClass)
{
  new Splide('.splide').mount;
}

const fvSplides = document.getElementsByClassName('splide fv');
if(fvSplides) {
  for (let i = 0; i < fvSplides.length; i++) {
    new Splide(fvSplides[i], {
      type  : 'fade',
      rewind: true,
      arrows: false,
      autoplay: true,
      heightRatio: 0.4166,
      breakpoints: {
        1025: {
          heightRatio: 1.661,
        }
      }
    }).mount();
  }
}


const splidesWorks = document.getElementsByClassName('splide__gallery splide');
if (splidesWorks) {
  for (let i = 0; i < splidesWorks.length; i++) {
    new Splide(splidesWorks[i], {
      type: "loop", // ループさせる
      arrows: false, // 矢印ボタンを非表示
      pagination: false, // ページネーションを非表示
      drag: "free", // フリードラッグモード
      perPage: 4, // 表示するスライドの枚数
      gap: '32px',
      breakpoints: {
        500: {
          perPage: 2, // 画面幅500px未満で表示枚数1枚
          gap: 0, // 画面幅500px未満でスライド間の余白0
        },
      },
      autoScroll: {
        speed: 0.8, // スクロール速度
        pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない
      },
    }).mount({ AutoScroll });
  }
}
const splidesVoice = document.getElementsByClassName('splide__voice splide');
if (splidesVoice) {
  for (let i = 0; i < splidesVoice.length; i++) {
    new Splide(splidesVoice[i], {
      type: "loop", // ループさせる
      arrows: false, // 矢印ボタンを非表示
      pagination: false, // ページネーションを非表示
      drag: "free", // フリードラッグモード
      perPage: 2, // 表示するスライドの枚数
      gap: '0px',
      autoScroll: {
        speed: 0.6, // スクロール速度
        pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない
      },
    }).mount({ AutoScroll });
  }
}
// new Splide('.splide', {
//   mediaQuery: 'min',
//   breakpoints: {
//     1024: {
//       destroy: true,
//       type: 'loop',
//       perPage: '1',
//     }
//   }
// }).mount();